import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../Firebase';
import PasswordResetModal from './PasswordResetModal';
import { toast } from 'react-toastify';
import Eyeclose from "../../images/eye-close.svg";

const LoginForm = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      toast('Login successfully', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('/dashboard');
    } catch (err) {
      toast.error('Login failed: invalid-credential', { className: 'toastify-error' });
      setError('Login failed: invalid-credential');
    }
  };

  const handleForgotPassword = async (email) => {
    if (!email) {
      alert('Please enter your email address.');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      alert('Password reset email sent! Check your inbox.');
      setShowModal(false);
      setResetEmail('');
    } catch (error) {
      console.error('Forgot password error');
      alert('Failed to send password reset email');
    }
  };

  return (
    <div className="login-box">
      <div className="head-info">
        <h2 className="mb-2">User Login</h2>
        <p>Welcome back! Please enter your credentials to access your ez1020 account!</p>
      </div>

      {error && <p className="text-danger">{error}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="johndoe@squch.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="password">Password</label>
          <div className="password-input">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              name="password"
              placeholder="password@123"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              className="toggle-password"
              aria-label="Toggle password visibility"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <img
                src={
                  showPassword
                    ? "https://c.animaapp.com/mcuhujz63FofVH/img/vuesax-linear-eye.svg"
                    : Eyeclose
                }
                alt={showPassword ? "Hide password" : "Show password"}
              />
            </button>
          </div>
        </div>

        <a
          href="#"
          className="forgot-password"
          onClick={(e) => {
            e.preventDefault();
            setResetEmail(formData.email);
            setShowModal(true);
          }}
        >
          Forgot password?
        </a>

        <div className="form-footer">
          <button type="submit" className="login-button">Log in</button>
          <p className="register-prompt">
            Don't have an account? <a href="/signup" className="register-link">Register Now</a>
          </p>
        </div>
      </form>

      <PasswordResetModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleForgotPassword}
        initialEmail={resetEmail}
      />
    </div>
  );
};

export default LoginForm;